import { render, staticRenderFns } from "./InternalReview.vue?vue&type=template&id=9e451622&scoped=true"
import script from "./InternalReview.vue?vue&type=script&lang=js"
export * from "./InternalReview.vue?vue&type=script&lang=js"
import style0 from "./InternalReview.vue?vue&type=style&index=0&id=9e451622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e451622",
  null
  
)

export default component.exports